import * as actionTypes from './actionTypes';
import * as api from './api';
import { Toast, normalize } from '../core';

export const getUsers = (companyId, params = {}) => dispatch => {
    dispatch({ type: actionTypes.GET_USERS.REQUEST, requestId: companyId });
    return api
        .getUsers(companyId, params)
        .then(response => {
            const { data, ...pagination } = response.data;
            dispatch({
                type: actionTypes.GET_USERS.SUCCESS,
                payload: {
                    companyId,
                    pagination,
                    ...normalize.normalizeArray(data)
                },
                requestId: companyId
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.GET_USERS.ERROR, requestId: companyId });
        });
};

export const loginAsUser = userId => dispatch => {
    dispatch({ type: actionTypes.LOGIN_AS_USER.REQUEST, requestId: userId });
    return api
        .loginAsUser(userId)
        .then(response => {
            Toast.success();
            dispatch({
                type: actionTypes.LOGIN_AS_USER.SUCCESS,
                payload: {
                    userId,
                    userData: response.data
                },
                requestId: userId
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.LOGIN_AS_USER.ERROR, requestId: userId });
        });
};

export const revokeAllAuthorizations = userId => dispatch => {
    dispatch({ type: actionTypes.REVOKE_ALL_USER_SESSIONS.REQUEST, requestId: userId });
    return api
        .revokeAllAuthorizations(userId)
        .then(() => {
            Toast.success();
            dispatch({ type: actionTypes.REVOKE_ALL_USER_SESSIONS.SUCCESS, requestId: userId });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.REVOKE_ALL_USER_SESSIONS.ERROR, requestId: userId });
        });
};

export const unlinkComrceOAuth = userId => dispatch => {
    dispatch({ type: actionTypes.UNLINK_COMRCE_OAUTH.REQUEST, requestId: userId });
    return api
        .unlinkComrceOAuth(userId)
        .then(() => {
            Toast.success('Comrce OAuth link removed successfully');
            dispatch({
                type: actionTypes.UNLINK_COMRCE_OAUTH.SUCCESS,
                payload: { userId },
                requestId: userId
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.UNLINK_COMRCE_OAUTH.ERROR, requestId: userId });
        });
};

export const disableTwoFA = userId => dispatch => {
    dispatch({ type: actionTypes.DISABLE_TWO_FA.REQUEST, requestId: userId });
    return api
        .disableTwoFA(userId)
        .then(() => {
            Toast.success();
            dispatch({
                type: actionTypes.DISABLE_TWO_FA.SUCCESS,
                payload: { userId },
                requestId: userId
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({
                type: actionTypes.DISABLE_TWO_FA.ERROR,
                requestId: userId
            });
        });
};

export const clearLoginAsUser = () => dispatch => {
    dispatch({ type: actionTypes.CLEAR_LOGIN_AS_USER });
};

export const unblockUser = userId => dispatch => {
    dispatch({ type: actionTypes.UNBLOCK_USER.REQUEST, requestId: userId });
    return api
        .unblockUser(userId)
        .then(response => {
            Toast.success();
            dispatch({
                type: actionTypes.UNBLOCK_USER.SUCCESS,
                payload: { userId },
                requestId: userId
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.UNBLOCK_USER.ERROR, requestId: userId });
        });
};

export const getUserActivities = (userId, params = {}) => dispatch => {
    dispatch({ type: actionTypes.GET_USER_ACTIVITIES.REQUEST, requestId: userId });
    return api
        .getUserActivities(userId, params)
        .then(response => {
            const { data, ...pagination } = response.data;
            dispatch({
                type: actionTypes.GET_USER_ACTIVITIES.SUCCESS,
                payload: {
                    userId,
                    pagination,
                    ...normalize.normalizeArray(data)
                },
                requestId: userId
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.GET_USER_ACTIVITIES.ERROR, requestId: userId });
        });
};

export const getAllUsers = (params = {}) => dispatch => {
    dispatch({ type: actionTypes.GET_ALL_USERS.REQUEST });
    return api
        .getAllUsers(params)
        .then(response => {
            const { data, ...pagination } = response.data;
            dispatch({
                type: actionTypes.GET_ALL_USERS.SUCCESS,
                payload: {
                    pagination,
                    ...normalize.normalizeArray(data)
                }
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.GET_ALL_USERS.ERROR });
        });
};

export const getUserNotifications = (userId, params = {}) => dispatch => {
    dispatch({ type: actionTypes.GET_USER_NOTIFICATIONS.REQUEST, requestId: userId });
    return api
        .getUserNotifications(userId, params)
        .then(response => {
            const { data, ...pagination } = response.data;
            dispatch({
                type: actionTypes.GET_USER_NOTIFICATIONS.SUCCESS,
                payload: {
                    userId,
                    pagination,
                    ...normalize.normalizeArray(data || [])
                },
                requestId: userId
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.GET_USER_NOTIFICATIONS.ERROR, requestId: userId });
        });
};

export const createNotification = data => dispatch => {
    dispatch({ type: actionTypes.CREATE_NOTIFICATION_FOR_ALL.REQUEST });
    return api
        .createNotification(data)
        .then(response => {
            Toast.success();
            dispatch({
                type: actionTypes.CREATE_NOTIFICATION_FOR_ALL.SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.CREATE_NOTIFICATION_FOR_ALL.ERROR });
        });
};

export const resetNextReviewDateForUser = userIds => dispatch => {
    dispatch({ type: actionTypes.RESET_NEXT_REVIEW_DATE_FOR_USERS.REQUEST });
    return api
        .resetNextReviewDateForUser(userIds)
        .then(() => {
            Toast.success();
            dispatch({ type: actionTypes.RESET_NEXT_REVIEW_DATE_FOR_USERS.SUCCESS });
        })
        .catch(error => {
            Toast.error(error);
            dispatch({ type: actionTypes.RESET_NEXT_REVIEW_DATE_FOR_USERS.ERROR });
        });
};
